<template>
  <div
    class="d-flex flex-column flex-wrap flex-md-row align-items-center ignore-box-sizing w-100 custom-gap"
  >
    <slot></slot>
    <b-button variant="primary" style="margin-top: 4px" @click="submitFilters">
      اعمال
    </b-button>
  </div>
</template>

<script>
export default {
  emits: ["submitFilters"],
  methods: {
    submitFilters() {
      this.$emit("submitFilters");
    },
  },
  components: {
    BButton,
  },
};
import { BButton } from "bootstrap-vue";
</script>
<style scoped>
.ignore-box-sizing * {
  box-sizing: border-box;
}
.custom-gap {
  gap: 0 10px;
}
</style>